import cx from 'classnames';
import { PropsWithChildren } from 'react';
import { asset } from '../../../services/assetResolverService';
import { LinkSharingAd } from '../linkSharingAd';

type TLinkSharingVariantProps = PropsWithChildren<{ className?: string; guideUrl: string }>;

export const LinkSharingRemixGuideAdVariant1 = (props: TLinkSharingVariantProps) => {
  return (
    <LinkSharingAd
      url={props.guideUrl}
      tag="icy-veins-legion-remix-v1"
      className={cx('iv-callout-button--v2', props.className)}
    >
      <span className="iv-callout-button__logo" aria-hidden="true">
        <img src={asset('/images/site/partners/iv_text_only.svg')} alt="Icy Veins" />
      </span>
      <span className={`iv-callout-button__title`}>Legion Remix Guide</span>
      <span className="iv-callout-button__imprint">
        <img src={asset('/images/site/partners/iv_imprint_only.svg')} alt="" />
      </span>
    </LinkSharingAd>
  );
};
